export default __webpack_public_path__ + "static/media/mon_eyes.b19944b9.jpg";